import { render, staticRenderFns } from "./MpLegend.vue?vue&type=template&id=6c3dabd8&scoped=true&"
import script from "./MpLegend.vue?vue&type=script&lang=js&"
export * from "./MpLegend.vue?vue&type=script&lang=js&"
import style1 from "./MpLegend.vue?vue&type=style&index=1&id=6c3dabd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3dabd8",
  null
  
)

export default component.exports